/**
 * iEngine.ts - Common base interface for all engine types
 * Pure ES Module version
 * Port of C# IEngine.cs
 */

import { MergeResult } from '../../model/index.js';
import { JsonObject } from '../../app/json/jsonValue.js';
import { PhaseTiming } from '../timing/phaseTiming.js';

/**
 * Common base interface for all engine types
 * Defines the shared contract for template merging
 * Engines are constructed with their specific loader type for type safety
 * All four engines share the same MergeTemplates signature and return MergeResult
 */
export class IEngine {
    /**
     * Merges templates by resolving placeholders, slots, and JSON data
     * Uses the loader provided at construction time
     * Returns MergeResult containing merged HTML, operations metadata, and dynamic handler results
     */
    mergeTemplates(
        appSite: string,
        appView: string | null,
        genOperationJson: boolean,
        genComponentHtml: boolean,
        contextJson: JsonObject | null,
        timing: PhaseTiming,
        configJson: JsonObject | null = null,
        actionMode: boolean = false,
        clientMode: boolean = false
    ): MergeResult {
        throw new Error('Method not implemented');
    }
}
